const getDataLayer = () => window?.dataLayer

const pushToDataLayer = (obj = {}) => {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log("%c[Data Layer]", "font-weight: bold", obj)
  } else {
    const dataLayer = getDataLayer()

    if (dataLayer) {
      dataLayer.push(obj)
    }
  }
}

export const trackEvent = (event, args = {}) => {
  pushToDataLayer({
    event,
    ...args,
  })
}
